// client/utilities/messaging/firebaseConfig.js

import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBJ_fRf_SyXgrWEKqw5OhN6WA8hdaXTd0M",
  authDomain: "peerless-text-370217.firebaseapp.com",
  projectId: "peerless-text-370217",
  storageBucket: "peerless-text-370217.appspot.com",
  messagingSenderId: "995510657000",
  appId: "1:995510657000:web:78dc22ccba1780d56c0e5d"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };